import Vue from "vue";
import Vuex from "vuex";
import modules from './modules'
import api from "@/api";
Vue.use(Vuex);

const userInfo = JSON.parse(localStorage.getItem("userInfo"))
const token = localStorage.getItem("token")

const store = new Vuex.Store({
  modules,
  state: {
    hasLogin: !!userInfo,
    userInfo: userInfo || {},
    token: token || "",
    cartNum: "",
    searchkeyword: "",
    categoryId: "",
    storekeyword: "",

  },
  mutations: {
    LOGIN(state, provider) {
      state.hasLogin = true;
      state.userInfo = provider.info;
      state.token = provider.token;
      localStorage.setItem("userInfo", JSON.stringify(provider.info));
      localStorage.setItem("token", provider.token);
      //console.log(state.userInfo);
    },
    LOGINOUT(state) {
      state.hasLogin = false;
      state.userInfo = {};
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("smActivity");
      localStorage.removeItem("startTime");
      sessionStorage.removeItem("isReplenish");
    },
    CHANGEAVATAR(state, provider) {
      state.userInfo.avatar = provider;
    },
    GETCARTCOUNT(state, provider) {
      state.cartNum = provider || 0;
    },
    SEARCHKEYWORD(state, provider) {
      state.searchkeyword = provider;
    },
    SET_CATEGORYID(state, provider) {
      state.categoryId = provider;
    },
    CGKEYWORD(state, provider) {
      state.storekeyword = provider;
    }
  },
  actions: {
    getCartNum({commit}){
      api.POST_CARTCOUNT().then(res => {
        if (res.status) commit("GETCARTCOUNT", res.data);
      });
    },
    getCartList({commit,state}){
      return api.GET_CART().then((res) => {
        if (res.status) {
          commit("GETCARTCOUNT", res.data.count);
          return res.data.items
        }
      });
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js